// Keep the existing Clarity property; the shared analytics consent owns loading.
export const CLARITY_PROJECT_ID = 'qlis9utyan';

export function createClarityConsent(window, document) {
  let script = null;
  let granted = false;
  let stopped = false;
  let loaderQueue;
  const consent = allowed => ({ ad_Storage: 'denied', analytics_Storage: allowed ? 'granted' : 'denied' });
  function queue() {
    if (typeof window.clarity !== 'function') {
      loaderQueue = function (...args) { (window.clarity.q ||= []).push(args); };
      window.clarity = loaderQueue;
    }
  }
  return {
    setConsent(choice) {
      const allowed = choice === 'granted';
      if (allowed === granted && (!allowed || script)) return;
      granted = allowed;
      if (!allowed) {
        if (!script && typeof window.clarity !== 'function') return;
        queue();
        // If the SDK is still downloading, discard the previous grant/events.
        // Removing a script alone cannot cancel code already being downloaded.
        if (Array.isArray(window.clarity.q)) window.clarity.q.length = 0;
        window.clarity('consentv2', consent(false));
        window.clarity('stop');
        stopped = true;
        return;
      }
      // Preserve the consent UI's promise to exclude rendered lyrics/account text,
      // including content teleported outside the app root.
      document.documentElement.setAttribute('data-clarity-mask', 'true');
      queue();
      if (window.clarity === loaderQueue) {
        // The SDK has not run yet. Keep only the latest choice, so a revoke /
        // re-grant during download cannot replay a stale stop after startup.
        window.clarity.q = [];
      } else if (stopped) {
        window.clarity('start');
      }
      stopped = false;
      window.clarity('consentv2', consent(true));
      if (script) return;
      const tag = document.createElement('script');
      tag.async = true;
      tag.referrerPolicy = 'no-referrer';
      tag.src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`;
      tag.onerror = () => {
        tag.remove();
        if (script === tag) script = null;
      };
      script = tag;
      document.head.appendChild(tag);
    },
  };
}
